import axios from "axios";

const TOKEN = process.env.REACT_APP_SUREPASS_TOKEN;

async function getPAN_cardDetails(panCardNumber) {
	const response = await axios
		.post(
			"https://kyc-api.aadhaarkyc.io/api/v1/pan/pan",
			{ id_number: panCardNumber },
			{
				headers: { Authorization: `Bearer ${TOKEN}` },
			}
		)
		.catch((error) => {
			return error;
		});
	return response;
}

async function getAadharCardDetails(aadharNumber) {
	// const response = await axios.post("https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-validation/aadhaar-validation", { "id_number": aadharNumber, "less_info": true }, {
	const response = await axios.post(
		"https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-validation/aadhaar-validation",
		{ id_number: aadharNumber },
		{
			headers: { Authorization: `Bearer ${TOKEN}` },
		}
	);

	return response;
}

async function getBankAccDetails(bankObj) {
	const response = await axios.post(
		"https://kyc-api.aadhaarkyc.io/api/v1/bank-verification/",
		{ id_number: bankObj.accountNo, ifsc: bankObj.ifscCode },
		{
			headers: { Authorization: `Bearer ${TOKEN}` },
		}
	);

	return response;
}

export { getPAN_cardDetails, getAadharCardDetails, getBankAccDetails };
